import { ControlledCustomSelect, Form } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { FORM_HINTS } from 'shared/config/formHints';

import { useOptions } from 'entities/pledgeAutoForm';

export const CarModel: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { models } = useOptions();

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={models}
      icon={<Form.FormHints.Tooltip text={FORM_HINTS.carModel} />}
    />
  );
};
